// extracted by mini-css-extract-plugin
export var modalFooter = "_sr-0";